export default class TaskQR {
    constructor(ob) {
        this.taskId = ob.taskId;
        this.pin = ob.pin;
    }

    static isTaskQR(ob) {
        return ob !== null &&
            Object.keys(ob).length === 2 &&
            ob.taskId !== undefined &&
            ob.pin !== undefined;
    }
}


// WEBPACK FOOTER //
// ./src/domain/TaskQR.js